export const styles = (theme) => ({
  tableContainer: {
    width: "99%",
  },
  frameTitle: {
    display: "flex",
    justifyContent: "space-between",
  },
  paperRoot: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  textField: {
    marginTop: theme.spacing(1),
  },
  inputDescription: {
    height: "auto",
  },
});
